import React from 'react'
import CellTag from 'syft-acp-uikit/components/AcpTable/cellComponents/CellTag/CellTag'

const BackupWorkerTag = ({ isDemandBuffer }: { isDemandBuffer: boolean | undefined }) => {
  if (!isDemandBuffer) return null
  return <CellTag value="Backup worker" slug="backup-worker" color="gray-light" />
}

export { BackupWorkerTag }
